import { Pipe, PipeTransform, LOCALE_ID, Injectable, inject } from '@angular/core';
import { capitalize } from '@panaya/utils';
import { SENTENCE_CASE_DICTIONARY, SentenceCaseDictionary } from './sentence-case-token';

@Pipe({
    name: 'sentenceCase'
})
@Injectable({
    providedIn: 'root'
})
export class SentenceCasePipe implements PipeTransform {
    private readonly locale = inject(LOCALE_ID);
    private readonly dictionary = inject(SENTENCE_CASE_DICTIONARY, { optional: true }) || createEmptyDictionary();

    public transform(value?: string): string {
        if (!value) {
            return '';
        }

        if (this.locale.startsWith('en-')) {
            return sentenceCase(value, this.dictionary);
        }

        return value;
    }
}

function sentenceCase(value: string, dictionary: SentenceCaseDictionary): string {
    return [(v: string): string => v.trim().toLowerCase(), removeSpacesFromSpecialPhrases, replaceSpecialWords, capitalize].reduce(
        (result, transform) => transform(result, dictionary),
        value
    );
}

function replaceSpecialWords(sentenceCaseValue: string, dictionary: SentenceCaseDictionary): string {
    for (let key in dictionary.MULTIPLE_WORDS_TO_UPPERCASE) {
        const index = sentenceCaseValue.indexOf(key);
        if (index >= 0) {
            sentenceCaseValue = sentenceCaseValue.replace(key, dictionary.MULTIPLE_WORDS_TO_UPPERCASE[key]);
        }
    }
    return sentenceCaseValue.replace(/([\w'"]+)/gm, (word) => dictionary.WORDS_TO_UPPERCASE[word.toLowerCase()] ?? word);
}

function removeSpacesFromSpecialPhrases(sentence: string, dictionary: SentenceCaseDictionary): string {
    return Object.entries(dictionary.PHRASE_WITH_SPACES).reduce(
        (result, [withSpace, withoutSpace]) => result.replace(withSpace, withoutSpace),
        sentence
    );
}

function createEmptyDictionary(): SentenceCaseDictionary {
    return {
        PHRASE_WITH_SPACES: {},
        WORDS_TO_UPPERCASE: {},
        MULTIPLE_WORDS_TO_UPPERCASE: {}
    };
}
